module.exports = __webpack_public_path__ + "img/notification.2d91dbcc.svg";